const flag = 'B2014LICHENG1009'
const db = window.localStorage
import config from '../lib/utils/config'
export default {
  save (key, val) {
    let res = val
    if (typeof val === 'object') {
      res = window.JSON.stringify(val)
    }
    res = this.convert(res, 1)
    db.setItem(key, res)
  },
  get (key) {
    let val = db.getItem(key)
    if (!val) {
      return
    }
    if (val.startsWith(flag)) { // plain text
      val = val.substring(flag.length)
    } else {
      try {
        val = this.convert(val, 2)
      } catch (err) {
        console.error(err)
        return null
      }
    }
    if (val && val.charAt(0) === '{') {
      return window.JSON.parse(val)
    }
    return val
  },
  delete (key) {
    db.removeItem(key)
  },
  convert (val, type) {
    if (val) {
      let x = window.Crypto.AES
      switch (type) {
        case 1:
          return x.encrypt(val, config.salt)
        case 2:
          return x.decrypt(val, config.salt)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/local.js